import {
    LOAD_API_DEPARTURE_DATA,
    LOAD_API_DEPARTURE_FAILED,
    LOAD_API_DEPARTURE_SUCCESS,
  } from "../types"
  
  const initialState = {
    serviceCards: [],
    loading: false,
    error: false,
    empty: false,
    loadType: null
  }

  export default function (state = initialState, action) {
    switch (action.type) {
      case LOAD_API_DEPARTURE_DATA:
        return {
          ...state,
          loading: true,
          error: false,
          empty: false,
          serviceCards: [],
          loadType: null
        }
      case LOAD_API_DEPARTURE_FAILED:
        return {
          ...state,
          loading: false,
          error: true,
          empty: false,
          serviceCards: [],
          loadType: null
        }
      case LOAD_API_DEPARTURE_SUCCESS:
        return {
          ...state,
          loading: false,
          error: false,
          empty: action.payload.data.length == 0,
          serviceCards: action.payload.data,
          loadType: action.payload.loadType
        }
      default:
        return state
    }
  }
  